import { WorkHonestlyTooltip } from "../WorkHonestlyTooltip";
import * as React from "react";
const styles = require("./index.css");

export const HonestWorkNew = () => {
  return (
    <div className={styles["wrapper"]}>
      <div className={styles["star"]} />
      <span className={styles["text"]}>Суперагент</span>
      <div className={styles["tooltip"]}>
        <WorkHonestlyTooltip />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/HonestWorkNew/index.tsx